import { DataSource, HorizontalSpacer, Label, Layout, Panel, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutHighwayControl extends Layout {
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    horizontalspacer3: HorizontalSpacer;
    horizontalspacer4: HorizontalSpacer;
    horizontalspacer5: HorizontalSpacer;
    horizontalspacer6: HorizontalSpacer;
    labelEquipmentTypeMapping: Label;
    panelServer: Panel;
    sourceCarrierInsControl: DataSource;
    sourceInterfaceCodes: DataSource;
    switchAddOrderHistComment: Switch;
    switchApproveCarriers: Switch;
    switchAutoAddOnInvite: Switch;
    switchEnableAdvances: Switch;
    switchExcludeContacts: Switch;
    switchExcludeEquipmentTypes: Switch;
    switchExcludePnnLanes: Switch;
    switchIncludeInactiveCarriers: Switch;
    switchIsActive: Switch;
    switchSaveLoadLockAlerts: Switch;
    switchSendLoadData: Switch;
    switchShowObservedLanes: Switch;
    tableHighwayEquipmentTypeMappings: Table;
    textboxCarrierStatus: Textbox;
    textboxContactNoResponseAction: Textbox;
    textboxContactUnknownAction: Textbox;
    textboxContactUnverifyAction: Textbox;
    textboxContactVerificationPref: Textbox;
    textboxFrequency: Textbox;
    textboxHighwayApiKey: Textbox;
    textboxImageDirectory: Textbox;
    textboxInsightsLocation: Textbox;
    textboxInsightsManagement: Textbox;
    textboxLastSyncDate: Textbox;
    textboxLoadDataSync: Textbox;
    textboxPacketWebsiteUrl: Textbox;
    textboxServer: Textbox;
}
